export function isNarrow({ size }) {
  return size === 'S';
}

export function needsFiller(rows, index) {
  const row = rows[index];

  if (row.size === 'L') {
    return false;
  }

  const nextRow = rows[index + 1];
  if (nextRow && nextRow.size === 'S') {
    return false;
  }

  const available = rows.slice(0, index);
  const total = available.reduceRight(
    ([smalls, bypass], row) => {
      if (bypass) {
        return [smalls, bypass];
      }
      if (row.size === 'L') {
        return [smalls, true];
      }
      return [smalls + 1, bypass];
    },
    [1, false]
  );

  // If there are an odd number of smalls, add filler.
  const [totalSmalls] = total;
  return totalSmalls % 2 !== 0;
}

export const organizeWidgetsByRow = (widgets) =>
  [...widgets].sort((a, b) => a.rowNumber - b.rowNumber);

function outOfRange(rowNumber, currentRow, newRow) {
  const belowRange = rowNumber < currentRow && rowNumber < newRow;
  const aboveRange = rowNumber > currentRow && rowNumber > newRow;
  return belowRange || aboveRange;
}

export function updateRows(widgets, currentRow, newRow = Infinity) {
  return widgets.map((widget) => {
    const { rowNumber } = widget;

    if (outOfRange(rowNumber, currentRow, newRow)) {
      return widget;
    }

    const difference = currentRow - newRow;
    const change = difference > 0 ? 1 : -1;

    if (rowNumber === currentRow) {
      return {
        ...widget,
        rowNumber: newRow
      };
    }

    return {
      ...widget,
      rowNumber: rowNumber + change
    };
  });
}

export const isWidgetLocked = (widget) =>
  !widget.isRemovable && !widget.isRepositionable && !widget.isResizable;
